<template>

    <div :class="cssInputClass + 'input-group | vn-input-' + (props?.field?.type ?? 'unknown' )">

        <label v-html="field.title"></label>

    </div>

</template>

<script>

export default
{
    name: "InputLabel"
}

</script>

<script setup>

    import useFormInput from "../../composables/useFormInput";

    let props = defineProps(["field"]);

    let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput(props);

    defineExpose(exposed);

</script>
